import { actions } from '../_redux';
import postAlert from '../../../assets/post-alert.mp3'

export class PostMessagesHandler {
	constructor() {
		this.messageHandler = this.handler.bind(this);
	}

	setInteractiveParams({ dispatch, filter, posts, setShowRefreshAlert }) {
		dispatch && (this.dispatch = dispatch);
		filter && (this.filter = filter);
		posts && (this.posts = posts);
		setShowRefreshAlert && (this.setShowRefreshAlert = setShowRefreshAlert);
	}

	subscribe() {
		window.addEventListener('message', this.messageHandler);
	}

	destroy() {
		window.removeEventListener('message', this.messageHandler);
	}

	handler(event) {
		try {
			const message = JSON.parse(event.data);
			this[message.type](message.payload || message.eventLabel || message);
		} catch (err) {
			// console.log('ignore');
		}
	}

	GA(adminId) {
		if (typeof adminId === 'string') {
			this.dispatch(actions.setAdminId(adminId));
		}
	}

	refreshCommunity(data) {
		if (this.filter.merchantId === 'all') {
			return;
		}
		const playSounds = localStorage.getItem('sounds');
		if (playSounds === 'true') {
			const notifAudio = new Audio(postAlert);
			notifAudio.play();
		}
		this.dispatch(actions.refreshCommunityPost(data));
	}
	notification(data) {
		if (this.filter.merchantId === 'all') {
			return;
		}
		const postId = data.message?.post?.postId || data.message?.post?.guid;
		if (postId) {
			this.dispatch(actions.refreshCommunityComment(data.message));
			return;
		}
	}
}
